import ExploreSvg from '@/assets/icons/click.svg?react'
import SearchSvg from '@/assets/icons/search.svg?react'
import DealsSvg from '@/assets/icons/shopping.svg?react'
import logo from '@/assets/images/logo.svg'
import type {UseMessagesReturn} from '@/components/ChatSection/hooks/useMessages'
import useTextTopics from '@/lib/chat/hooks/useTextTopics'

import style from './DefaultMessage.module.scss'

export type TextTopics = Partial<Record<'find' | 'explore' | 'deals', string[]>>

interface Props {
  submitMessage: UseMessagesReturn['submitMessage']
  focusToMessageInput: () => void
}

const COLORS = ['#C52732', '#00B8FF', '#FC9502', '#7B61FF', '#08BF47', '#D400CC']
let colorIndex = 0

export default memo<Props>(function DefaultMessage({submitMessage, focusToMessageInput}) {
  const {data: textTopics} = useTextTopics()

  colorIndex = 0

  return (
    <div className={style.DefaultMessage} title='Get started'>
      <img className={style.Logo} src={logo} alt='InnoSearch' aria-hidden='true' />
      <div className={style.GuideText} title='Welcome text'>
        <p>
          Hi there! I&apos;m your AI-driven shopping buddy, ready to assist with all your shopping
          needs.
        </p>
        <p>Chat with me to:</p>
        <ul>
          <li>Browse the hottest deals and discounted products across hundreds of stores.</li>
          <li>Find the perfect product for your needs.</li>
          <li>Get expert and user recommendations to guide your decision.</li>
        </ul>
      </div>
      {textTopics && Object.entries(textTopics).length > 0 && (
        <div className={style.TextTopics} title='Suggested topics'>
          {textTopics.find && (
            <div className={style.TextTopic} title='Find products'>
              <div className={style.Text}>
                {textTopics.find.map(text => (
                  <button
                    key={text}
                    onClick={() => {
                      submitMessage(text)
                      focusToMessageInput()
                    }}
                    style={{
                      borderLeftColor: COLORS[colorIndex++ % COLORS.length],
                    }}
                  >
                    {text}
                  </button>
                ))}
              </div>
              <div className={style.TextIcon} aria-hidden>
                <SearchSvg aria-hidden />
              </div>
            </div>
          )}
          {textTopics.deals && (
            <div className={style.TextTopic} title='Find deals'>
              <div className={style.Text}>
                {textTopics.deals.map(text => (
                  <button
                    key={text}
                    onClick={() => {
                      submitMessage(text)
                      focusToMessageInput()
                    }}
                    style={{
                      borderLeftColor: COLORS[colorIndex++ % COLORS.length],
                    }}
                  >
                    {text}
                  </button>
                ))}
              </div>
              <div className={style.TextIcon} aria-hidden>
                <DealsSvg aria-hidden />
              </div>
            </div>
          )}
          {textTopics.explore && (
            <div className={style.TextTopic} title='Research products'>
              <div className={style.Text}>
                {textTopics.explore.map(text => (
                  <button
                    key={text}
                    onClick={() => {
                      submitMessage(text)
                      focusToMessageInput()
                    }}
                    style={{
                      borderLeftColor: COLORS[colorIndex++ % COLORS.length],
                    }}
                  >
                    {text}
                  </button>
                ))}
              </div>
              <div className={style.TextIcon} aria-hidden>
                <ExploreSvg aria-hidden />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )
})
